const shopName = 'mtka-tree-sale';
const accessToken = '25167b95dae204e2adb0a78866896838';

async function totalCartQuantityIsValid(lineItemId, quantity, productTitle) {
    try {
        const cartQuantity = await totalCartQuantity(lineItemId, quantity, productTitle);
        console.log(cartQuantity);
        return cartQuantity <= 1;
    }
    catch (error) {
        console.log(error);
    }
}

async function totalCartQuantity(lineItemId, quantity, productTitle) {
  	console.log('product title: ' + productTitle);
    let cart;
    try {
        cart = await $.ajax({
            type: 'GET',
            url: '/cart.js',
            dataType: 'json'
        });

        let totalQuantity = 0;
        $.each(cart.items, function (index, cartItem) {
          console.log(cartItem.title);
          if(!cartItem.title.includes("Bag") && !cartItem.title.includes("Guard")){
            if (lineItemId === cartItem.id) {
                //updating existing cart quantity
                totalQuantity += parseInt(quantity);
            }
            else {
                totalQuantity += cartItem.quantity;
            }
          }
        });

        if (lineItemId === 0) {
          let product;
            //add to cart from product detail
          if(!productTitle.includes("Bag") && !productTitle.includes("Guard")){
            totalQuantity += parseInt(quantity);
          }
        }

        return totalQuantity;
    }
    catch (error) {
        console.log(error);
    }
}

function quantityPerOrderLimitMessage(quantity) {
    return 'We\'re sorry, we cannot process this action.  Adding this additional quantity (' + quantity + ') would exceed the quantity-per-order limit of 1.'
}
